import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommPerformanceDataList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceMCPerformanceData: DataSource;
    tableMCPerformanceData: Table;
}
